import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base/use-case.js";
import { GetVehicleGroupRequest } from "../../domain/requests/vehicle-group/vehicle-group.js";
import { VehicleGroup } from "../../domain";
import { VehicleGroupRepository } from "../../repositories/vehicle-group.repository";
import { VehicleGroupDto } from "../../domain/requests/vehicle-group/create-edit-vehicle-group-request.js";

@Injectable()
export class UpdateVehicleGroupUsecase implements UseCase<VehicleGroupDto[], boolean> {

  constructor(private vehicleGroupRepository: VehicleGroupRepository) {
  }

  execute(request:VehicleGroupDto[]): Observable<boolean> {
    return this.vehicleGroupRepository.updateVehicleGroup(request);
  }

}
